<div class="recording-control" *ngIf="(stateService.isRecordingEnabled$ | async) === true">
  <stusan-control-button [tooltipText]="(recordingState$ | async) === 'recording' ? 'Stop recording' : 'Start recording'"
                         (click)="toggleRecording()"
  >
    <thevatra-progress-indicator *ngIf="(loading$ | async)"></thevatra-progress-indicator>
    <stusan-toggle-icon
      [label]="'Rec'"
      [labelColor]="(recordingState$ | async) !== 'recording' ? 'toggle' : 'default'"
      [icon]="(recordingState$ | async) !== 'recording' ? 'menu-rec-on' : 'menu-rec-off'"
      [hover]="(recordingState$ | async) !== 'recording'"
      [state]="(recordingState$ | async) !== 'recording'"
      [ngClass]="{
        'hidden': (loading$ | async)
      }"
    ></stusan-toggle-icon>
  </stusan-control-button>
</div>

